// Admin/dev identity is a server-side flag, not anything baked into the client.
// `profiles.is_admin` is set ONLY from the Supabase SQL editor (the column is
// stripped from the client's UPDATE grant — see schema.sql), so a player can't
// make themselves an admin. The same flag backs the RLS policy that authorises
// scoreboard deletes, so the protection lives in the database, not here.
export function isAdmin(
  profile: { is_admin?: boolean | null } | null | undefined,
): boolean {
  return !!profile?.is_admin;
}
